import {
  IAHU,
  IAHUMapping,
} from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

const apiVersion = 'v1';

const getAHUById = async (
  vavId: number,
  options: { signal?: AbortSignal } = {}
): Promise<IAHU> => {
  try {
    const { signal } = options;

    const response = await window.axios.get(
      `/${apiVersion}/AirHandlerUnits/${vavId}`,
      { signal }
    );

    const { data } = response.data;
    return data as IAHU;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getAHUsBySiteId = async (siteId: string | number) => {
  const response = await window.axios.get(
    `${apiVersion}/AirHandlerUnits/latest-readings?siteid=${siteId}`
  );

  const { data } = response.data;
  return data as IAHU[];
};

const getAHUSettingsMessages = async (ahuId: number) => {
  try {
    const response = await window.axios.get(
      `${apiVersion}/AirHandlerUnits/${ahuId}/history`
    );

    const { data } = response.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const updateAHUById = async (ahu: IAHU) => {
  const {
    deviceId,
    friendlyName,
    siteLocationId,
    equipmentId = null,
    isActive = true,
  } = ahu;
  try {
    await window.axios.put(`${apiVersion}/AirHandlerUnits/${deviceId}`, {
      friendlyName,
      siteLocationId,
      equipmentId,
      isActive,
    });
  } catch (err) {
    return Promise.reject(err);
  }
};

const deleteAHUById = async (ahuId: number) => {
  try {
    await window.axios.delete(`${apiVersion}/AirHandlerUnits/${ahuId}`);
  } catch (err) {
    return Promise.reject(err);
  }
};

const getSitesWithAHUs = async () => {
  try {
    const result = await window.axios.get(
      `${apiVersion}/AirHandlerUnits/sites`
    );
    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getAHUMappings = async (
  siteId: string | number
): Promise<IAHUMapping[]> => {
  try {
    const result = await window.axios.get(
      `${apiVersion}/AirHandlerUnits/sites/${siteId}/mappings`
    );
    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export default {
  getAHUById,
  getAHUsBySiteId,
  updateAHUById,
  deleteAHUById,
  getAHUSettingsMessages,
  getSitesWithAHUs,
  getAHUMappings,
};
